module.exports = __webpack_public_path__ + "static/media/ID.5e74a225.svg";